import en from './en.js'

const zh = {
  ...en,
  common: {
    ...en.common,
    aiPet: 'AI伙伴',
    backHome: '返回首页',
    loading: '加载中',
    login: '登录',
    logout: '退出登录',
    manageAdmin: '后台管理',
    myAccount: '我的账户',
    myFavorites: '我的收藏',
    myGithub: '我的 GitHub',
    register: '注册',
    retry: '重试',
    userCenter: '个人中心',
  },
  header: {
    languageSwitchToEnglish: '英文',
    languageSwitchToChinese: '中文',
  },
  nav: {
    ...en.nav,
    aria: '主导航',
    brand: '青途 AI',
    brandSub: '大学生成长与职业规划平台',
    closeMenu: '关闭导航菜单',
    home: '首页',
    language: '语言',
    mobileAria: '移动端导航',
    more: '更多',
    openMenu: '打开导航菜单',
    navHome: '首页',
    navGrowth: '我的成长',
    navExplore: '探索方向',
    navProjectsResume: '成果库',
    navAiPartner: 'AI伙伴',
    navMore: '更多',
  },
  moreMenu: {
    ...en.moreMenu,
    title: '更多功能',
    competitions: '竞赛',
    competitionsDesc: '按专业和目标寻找适合的竞赛。',
    certificates: '证书',
    certificatesDesc: '在合适阶段规划证书准备。',
    interview: '面试',
    interviewDesc: '按目标岗位准备自我介绍、项目表达和面试题。',
    resume: '简历',
    resumeDesc: '检查简历并生成可直接修改的优化建议。',
    aiTools: 'AI工具',
    aiToolsDesc: '查找适合学习、项目和求职的AI工具。',
    dailyRanking: '每日榜单',
    dailyRankingDesc: '查看今日热门项目。',
    allTimeRanking: '总榜',
    allTimeRankingDesc: '查看长期趋势项目。',
    todayPicks: '今日推荐',
    todayPicksDesc: '浏览今天适合关注的工具和项目。',
    githubAnalysis: 'GitHub分析',
    githubAnalysisDesc: '分析项目亮点、简历价值和面试表达。',
    vip: '会员权益',
    vipDesc: '查看会员权益和使用额度。',
    support: '支持与反馈',
    supportDesc: '提交激活、退款和问题反馈。',
    profile: '个人中心',
    profileDesc: '查看账户、收藏和个人资料。',
    loginProfileDesc: '登录后进入个人中心。',
    admin: '管理后台',
    adminDesc: '仅管理员可见。',
  },
  homeGrowth: {
    ...en.homeGrowth,
    metaTitle: '青途 AI - 大学生成长与职业规划平台',
    metaDescription: '青途 AI 帮助大学生找到方向，规划成长，走向未来。',
    eyebrow: '青途 AI',
    title: '把大学成长变成每天能推进的一步',
    titleLine1: '把大学成长',
    titleLine2: '变成每天能推进的一步',
    subtitle: '从探索方向到职业准备，青途 AI 陪你规划路径、积累能力、完成项目，走向更好的未来。',
    routeIntro: '成长路线：认识自己 → 找到方向 → 制定计划 → 完成任务 → 沉淀成果',
    start: '开始探索我的方向',
    continue: '继续我的成长',
    checking: '正在检查成长状态...',
    secondary: '探索新方向',
    secondaryGuest: '查看成果库',
    knowMe: '让我更加了解你',
    partnerCardTitle: 'AI伙伴成长状态',
    partnerUpdated: '今日更新',
    partnerGuide: '等待认识你',
    partnerObservation: '小助手观察：你正在朝“{{direction}}”推进，今天适合完成一个可见的小动作。',
    partnerEmptyObservation: '小助手观察：还没有成长记录。先从方向探索开始，我会帮你把困惑变成下一步。',
    heroSceneLabel: 'AI伙伴成长状态演示',
    petSpeechTitle: '嗨，我是你的成长伙伴',
    petSpeechReady: '今天继续推进一个小目标吧。',
    petSpeechEmpty: '先让我认识你，再一起规划方向。',
    companionPanelTitle: 'AI伙伴陪伴',
    companionPanelActive: '正在陪你推进',
    companionPanelEmpty: '等待开始',
    companionChat: '和小助手聊当前困惑',
    companionRecord: '查看成长记录',
    companionNurture: '宠物养成一起成长',
    emptyDirection: '待探索方向',
    emptyStage: '方向探索阶段',
    emptyAdvice: '先完成一次方向探索',
    defaultAdvice: '完成今天最小的一步',
    statusLabel: '成长状态',
    statusTitle: '不是工具列表，而是你的当前进度',
    statusDirection: '当前方向',
    statusStage: '当前阶段',
    statusAdvice: '今日建议',
    statusProgress: '成长进度',
    overviewLabel: '成长数据',
    overviewTitle: '你的成长会被持续记录',
    overviewStreak: '连续成长',
    overviewTasks: '完成任务',
    overviewProjects: '项目经验',
    overviewCertificates: '证书/成果',
    daysCount: '{{count}} 天',
    notStarted: '未开始',
    modulesLabel: '四大成长模块',
    modulesTitle: '从方向到成果，按学生真实路径组织',
    modulesDesc: '每个模块都服务于同一个目标：让你知道下一步做什么，并留下能复盘、能展示的成长证据。',
    moduleExploreTitle: '探索方向',
    moduleExploreDesc: '从专业、兴趣、学习习惯和目标出发，找到更适合当前阶段的方向。',
    moduleLearningTitle: '学习路线',
    moduleLearningDesc: '把方向拆成阶段和任务，避免只收藏资料却不知道怎么开始。',
    moduleProjectTitle: '项目实践',
    moduleProjectDesc: '把课程、练习和想法变成可展示的项目成果。',
    moduleCareerTitle: '求职准备',
    moduleCareerDesc: '整理简历材料、项目表达和面试准备，让成果能被看见。',
    moduleCta: '进入',
    partnerLabel: 'AI伙伴',
    partnerTitle: '陪你把模糊想法整理成下一步',
    partnerDesc: 'AI伙伴会结合你的方向、阶段、任务和成长事件，给出更贴近当天状态的建议。',
    partnerCta: '和AI伙伴聊聊',
    todayLabel: '今日成长任务',
    todayTitle: '今天只推进最重要的一步',
    todayDesc: 'AI伙伴会根据当前方向和阶段，把成长目标拆成今天可完成的任务。',
    todayEmptyDesc: '还没有成长计划时，先完成一次方向探索，AI伙伴会生成第一阶段任务。',
    todayEmptyTask: '完成一次方向探索，建立你的成长画像',
    confusionLabel: '从真实学生困惑开始',
    confusionTitle: '先从你现在遇到的问题进入',
    confusionDesc: '不知道方向、没有节奏、缺少成果，对应的是三条不同路径。',
    confusionDirectionTitle: '不知道方向',
    confusionDirectionDesc: '从专业、兴趣、性格和期待生活方式出发，探索更适合你的方向。',
    confusionDirectionCta: '去探索方向',
    confusionImproveTitle: '不知道怎么提升',
    confusionImproveDesc: '把模糊目标变成学习路线、今日任务和可复盘进度。',
    confusionImproveCta: '查看我的成长',
    confusionOutcomeTitle: '没有成果准备就业',
    confusionOutcomeDesc: '补项目、改简历，沉淀实习或求职能使用的证明材料。',
    confusionOutcomeCta: '去积累成果',
    loopLabel: '成长闭环',
    loopTitle: '首页只负责把你带到下一步',
    loopDesc: '后续功能都围绕同一条成长路径展开，不在首页堆工具。',
    loopSelf: '认识自己',
    loopSelfDesc: '从年级、基础、兴趣和压力开始。',
    loopDirection: '找到方向',
    loopDirectionDesc: '比较更符合当前状态的发展路径。',
    loopPlan: '制定计划',
    loopPlanDesc: '把方向拆成能学习的阶段。',
    loopTask: '完成任务',
    loopTaskDesc: '少逛功能，多完成今天该做的事。',
    loopOutcome: '积累成果',
    loopOutcomeDesc: '把学习和实践变成项目与简历证据。',
    caseLabel: '学生案例',
    caseTitle: '不同学生，从不同问题进入',
    caseDesc: '产品不需要学生先理解所有功能，也应该能让他知道下一步。',
    casePrefix: '案例',
    caseFreshmanTitle: '大一，还没想清楚方向',
    caseFreshmanDesc: '先做自我了解和方向探索，再保存一个本学期可执行的小计划。',
    caseSophomoreTitle: '大二，感觉落后又不知道补什么',
    caseSophomoreDesc: '从成长中心继续，按周推进学习路线，用任务找回节奏。',
    caseInternTitle: '准备实习，但成果不够',
    caseInternDesc: '进入成果库，补项目包装、简历优化和GitHub证明材料。',
    capabilityLabel: '产品能力',
    capabilityTitle: '需要时再进入具体工具',
    capabilityDesc: '学习路线、项目、简历、GitHub和AI伙伴仍然保留，但它们服务于你的成长目标。',
    learningTitle: '学习路线',
    learningDesc: '根据目标和基础，跟随更适合自己的学习路径。',
    projectTitle: '项目',
    projectDesc: '把课程和练习变成可展示的作品证据。',
    resumeTitle: '简历',
    resumeDesc: '把经历包装成更适合求职表达的结构。',
    githubTitle: 'GitHub趋势',
    githubDesc: '把趋势当作机会线索，而不是孤立工具。',
    companionTitle: 'AI伙伴',
    companionDesc: '聊清楚当前情况，获得下一步建议。',
    finalTitle: '先从你的当前状态开始',
    finalDesc: '不需要先理解所有功能。完成一次方向探索，青途 AI 会把你带回每天能推进的成长路径。',
  },
  authMarketing: {
    ...en.authMarketing,
    featuresAria: '青途 AI 能帮助你的方向',
    loginTitle: '登录 - 青途 AI',
    registerTitle: '注册 - 青途 AI',
    loginDescription: '登录后继续你的方向探索、学习路线、项目成果和求职准备。',
    registerDescription: '创建账户，开始规划你的大学成长路径。',
    title: '用AI规划你的大学成长路径',
    description: '从探索、学习到项目、简历和求职准备，AI陪你一步步成长。',
    feature1Title: '方向探索',
    feature1Desc: '找到更适合你的发展方向和成长路线',
    feature2Title: '学习计划',
    feature2Desc: '根据专业、目标和基础生成学习计划',
    feature3Title: '项目实践',
    feature3Desc: '获得项目想法、实践任务和动手路径',
    feature4Title: '求职准备',
    feature4Desc: '简历优化、岗位匹配和面试准备',
    previewLabel: '成长路线',
    previewTag: 'AI计划',
    previewTitle: '大学成长任务卡',
    previewDesc: '把探索、技能学习、项目实践和求职准备变成每天能完成的行动。',
    badge1: '职业规划',
    badge2: '学习路径',
    badge3: '求职准备',
  },
  authForm: {
    ...en.authForm,
    loginHeading: '欢迎回来',
    registerHeading: '创建成长账户',
    loginIntro: '登录后继续你的学习路线、项目实践、简历优化和求职准备。',
    registerIntro: '创建账户，保存你的成长路线、学习计划、项目实践和求职准备进度。',
    githubLogin: '使用 GitHub 继续',
    githubProcessing: '处理中...',
    githubUnavailable: '暂未配置 GitHub 登录',
    githubFallback: '请使用账号密码登录。',
    divider: '或使用账号密码',
    username: '用户名',
    usernameOrEmail: '用户名或邮箱',
    usernamePlaceholder: '设置你的用户名',
    usernameOrEmailPlaceholder: '输入用户名或邮箱',
    email: '邮箱',
    emailPlaceholder: '用于接收验证邮件',
    password: '密码',
    passwordPlaceholder: '输入密码',
    newPasswordPlaceholder: '至少 8 个字符',
    confirmPassword: '确认密码',
    confirmPasswordPlaceholder: '再次输入密码',
    forgotPassword: '忘记本地账号密码？',
    humanCheck: '真人验证',
    loginHumanTitle: '登录前确认是本人操作',
    loginHumanDesc: '这是一个轻量前端确认，用来减少自动化脚本反复尝试登录。',
    loginHumanQuestion: '请输入 {{question}} 的结果',
    loginHumanPlaceholder: '答案',
    loginHumanRefresh: '换一题',
    submitLogin: '登录并继续',
    submitRegister: '注册并发送验证邮件',
    completeHumanCheck: '请完成上方安全验证',
    processing: '处理中...',
    hasAccount: '已有账号？',
    noAccount: '还没有账号？',
    goLogin: '去登录',
    createAccount: '创建账户',
  },
  auth: {
    ...en.auth,
    inputUsername: '请输入用户名。',
    inputEmail: '请输入邮箱地址。',
    inputPassword: '请输入密码。',
    passwordLength: '密码至少需要 8 个字符。',
    passwordMismatch: '两次输入的密码不一致。',
    turnstileMissing: '真人验证尚未配置，请联系管理员。',
    humanCheck: '请先完成人机验证。',
    turnstileLazyHint: '点击注册后将自动加载安全验证，无需提前等待。',
    turnstileLoading: '正在加载安全验证...',
    turnstileRetrying: '验证未通过，正在重新获取验证...',
    turnstileVerified: '安全验证已通过，正在提交注册...',
    turnstileLoadFailed: '安全验证加载失败，请刷新后重试',
    turnstileVerificationFailed: '安全验证未通过，请重新完成验证。',
    turnstileRetry: '重新加载验证',
    turnstileUnavailable: '安全验证服务暂时不可用，请稍后重试。',
    requestFailed: '操作未完成，请稍后重试。',
    loginHumanCheck: '请先完成登录前的人机确认。',
    verificationResent: '验证邮件已重新发送。',
    githubMissingUrl: 'GitHub 登录暂不可用。',
    githubLoginFailed: 'GitHub 登录失败，请尝试账号登录。',
    emailVerification: '邮箱验证',
    verifyTitle: '验证邮箱后即可激活账户',
    verifySent: '我们已经向你的邮箱发送验证邮件。',
    verifyCreated: '账户已创建，请先验证邮箱再登录。',
    verifyNote: '如果没有看到邮件，可以检查垃圾箱或重新发送。',
    resend: '重新发送邮件',
    emailVerified: '我已验证，去登录',
    turnstileProdMissing: '真人验证尚未配置，暂时无法注册。',
    turnstileDevMissing: '本地开发环境已跳过真人验证。',
    registrationSuccessRedirect: '注册成功。验证邮件已发送至：',
    emailAlreadyExists: '该邮箱已注册，请直接登录或找回密码。',
    usernameAlreadyExists: '该用户名已被使用，请更换用户名。',
    unverified: '这个账户还没有完成邮箱验证。',
    resendNow: '重新发送验证邮件',
  },
  growthCenter: {
    ...en.growthCenter,
    taskFallbackTitle: '成长任务',
    eventFallbackTitle: '成长记录',
    project: '项目',
    resume: '简历',
    interview: '面试',
    learning: '学习',
    currentTarget: '当前目标',
    fallbackLearningTask: '梳理 {{target}} 需要的 3 个核心能力',
    fallbackProjectTask: '选择一个能写进简历的项目',
    fallbackResumeTask: '补充一段和目标相关的简历经历',
    emptyEyebrow: '青途 AI',
    emptyTitle: '先完成方向探索，再生成你的成长路线',
    emptyDesc: '方向会成为成长中心、今日任务、项目建议、竞赛证书和练习任务的共同目标。',
    aboutThreeMinutes: '约 3 分钟',
    beginnerFirst: '新手友好',
    dailyTasks: '今日任务',
    generateChangePlan: '探索我的方向',
    myProjectResults: '我的项目成果',
    heroTitle: '每天知道下一步，也看得见长期路线',
    heroDesc: '成长中心会围绕你的当前目标，持续推进学习、项目、竞赛证书、简历和面试准备。',
    adjustGoal: '调整成长目标',
    loadFailedTitle: '加载失败，请刷新或提交反馈',
    retry: '重试',
    submitFeedback: '提交反馈',
    todayTasks: '今日成长任务',
    loadingTodayTasks: '正在加载今日任务...',
    remainingTasks: '今天还剩 {{count}} 项任务',
    estimatedXp: '预计 {{minutes}} 分钟，{{xp}} 成长值。',
    dailyDesc: '从迷茫到作品、简历和面试，一步一步推进。',
    progressLabel: '完成进度 {{progress}}%',
    startTodayPlan: '开始今日计划',
    closedLoop: '成长数据闭环',
    weeklyReport: '本周成长报告',
    closedLoopFallback: '系统会根据学习、练习、项目和求职动作给出下一步建议。',
    learningTime: '学习时长',
    minutes: '{{count}} 分钟',
    learningTimeDesc: '来自学习节点、练习和项目推进',
    completedTasks: '已完成任务',
    completedTasksDesc: '学习和练习完成后会自动统计',
    abilityGrowth: '能力成长',
    abilityGrowthDesc: '基于学习完成度和练习表现',
    projectProgress: '项目进度',
    projectProgressDesc: '来自项目任务和成果提交',
    todayAdvice: '今日建议',
    noRecentActivity: '还没有近期动作，先完成一个学习任务。',
    learningOverview: '学习概览',
    currentDirection: '当前方向',
    routeProgress: '路线完成 {{progress}}% · 当前阶段 {{stage}}',
    notStarted: '未开始',
    practiceAndProject: '练习与项目',
    projectLabel: '项目：{{label}}',
    noActiveProject: '暂无进行中项目',
    nextSuggestion: '下一步建议',
    streakDays: '连续成长 {{count}} 天',
    nextSuggestionFallback: '先完成下一个学习节点，再做 2 个基础练习。',
    levelAria: '成长等级和成长值',
    growthLevel: '成长等级',
    growthLevelDesc: '完成任务和阶段后会持续提升',
    growthValue: '成长值',
    growthValueDesc: '任务、路线和时间线记录都会累计',
    timelineCount: '时间线',
    timelineFallback: '保存计划后，关键成长动作会记录在这里',
    learningRoute: '学习路线',
    stagesCompleted: '已完成 {{done}}/{{total}} 个阶段',
    viewFullRoute: '查看完整路线',
    currentStage: '当前阶段',
    none: '暂无',
    createPlanForRoute: '先完成方向探索，再生成学习路线。',
    nextStage: '下一阶段',
    finalStage: '已到最后阶段',
    finalStageDesc: '继续完善简历和面试表达。',
    stageOrder: '阶段 {{order}}',
    loading: '正在加载...',
    loadingLong: '如果加载过久，可以刷新或提交反馈。',
    noTasksTitle: '今天还没有任务',
    noTasksDesc: '先在探索方向里生成你的第一个成长计划。',
    goCareerPlanner: '去探索方向',
    markDone: '标记完成',
    done: '已完成',
    updatedAt: '更新时间：{{time}}',
    trainingActive: '练习进行中',
    itemCount: '{{count}} 项',
    trainingFallback: '练习任务已生成，继续推进今日任务。',
    competitionPrep: '竞赛准备',
    competitionFallback: '已加入成长计划，继续生成竞赛相关任务。',
    certificatePrep: '证书准备',
    certificateFallback: '已加入成长计划，继续生成证书相关任务。',
    growthTimeline: '成长时间线',
    recentRecords: '最近记录',
    timelineDesc: '计划、任务完成、项目和学习资源会记录在这里。',
    waitingFirstRecord: '等待第一条记录',
    firstRecordTitle: '先完成一次方向探索或今日任务',
    firstRecordDesc: '关键成长动作会同步到时间线，方便复盘。',
    trainingAssistant: '练习助手',
    majorDirections: '专业方向',
    competitionPlanning: '竞赛规划',
    certificatePlanning: '证书规划',
    projectRecommendations: '项目建议',
    resumeOptimization: '简历优化',
    interviewPrep: '面试准备',
  },
  growthDaily: {
    ...en.growthDaily,
    eyebrow: '我的成长',
    title: '今天，先完成最有用的下一步',
    subtitle: '你的目标、阶段、任务、建议和最近成果都集中在这里，不必来回找功能。',
    currentState: '当前成长状态',
    currentGoal: '当前目标',
    currentStage: '当前阶段',
    stageProgress: '阶段进度',
    progressValue: '{{progress}}%',
    existingPlanGoal: '已有成长计划',
    existingPlanStage: '继续当前计划',
    noGoal: '还没有目标',
    noStage: '还没有阶段',
    todayTasks: '今日任务',
    pendingTasks: '还有 {{count}} 项待完成',
    allDone: '今天的任务已完成',
    nextAdvice: '下一步建议',
    companionAdvice: 'AI伙伴观察',
    companionObservationPending: '小助手观察：你的目标是“{{goal}}”，今天还有 {{count}} 项任务没有完成。先推进最小的一步，比继续浏览功能更重要。',
    companionObservationDone: '小助手观察：你今天已经推进了“{{goal}}”。接下来适合做一次简短复盘，把进展变成可展示记录。',
    companionObservationNoGoal: '小助手观察：现在还没有明确成长目标。建议先完成方向探索，让后续任务围绕一个真实目标展开。',
    companionActionTask: '今天建议先完成：{{task}}',
    recentOutcomes: '最近成果',
    secondaryActions: '更多成长记录',
    report: '周报',
    reportDesc: '查看本周成长复盘。',
    timeline: '成长时间线',
    timelineDesc: '回看关键进展。',
    timelineLoginTitle: '登录后查看你的成长时间线',
    timelineLoginDesc: '计划、任务完成、学习记录和项目成果会在登录后沉淀到这里。',
    timelineTitle: '成长时间线',
    timelinePageDesc: '回看你的方向选择、任务完成、学习推进和成果沉淀。',
    backToGrowth: '回到我的成长',
    timelineLoadFailed: '成长时间线加载失败，请稍后再试。',
    eventFallback: '成长记录',
    eventFallbackDesc: '一次新的成长动作。',
    waitingFirstRecord: '等待第一条记录',
    firstRecordTitle: '完成一次任务后会出现在这里',
    firstRecordDesc: '方向探索、学习节点、项目成果和简历优化都会成为成长记录。',
    assets: '成长资产',
    assetsDesc: '管理项目、证书和简历素材。',
    startDiagnosis: '开始成长诊断',
    adjustGoal: '调整目标',
    viewLearning: '查看学习路线',
    viewAssets: '查看成果库',
    findDirection: '探索方向',
    markDone: '标记完成',
    done: '已完成',
    doNext: '去完成',
    openToday: '打开今日任务',
    createFirstTask: '先生成今日任务',
    taskFallback: '完成一个和当前目标有关的小任务',
    taskMeta: '{{minutes}} 分钟 · {{xp}} 成长值',
    taskDesc: '完成后会同步到你的成长记录。',
    nextFallbackTitle: '先确定一个成长方向',
    nextFallbackDesc: '完成方向探索后，系统会给出更具体的目标、任务和成果建议。',
    noTaskStatus: '等待生成任务',
    noTaskTitle: '今天还没有任务',
    noTaskDesc: '完成成长诊断或生成计划后，这里会出现今天该做的事。',
    noOutcomeTitle: '还没有最近成果',
    noOutcomeDesc: '完成项目、简历优化或学习任务后，会在这里留下可复盘的成果。',
    outcomeSummary: '成果概览',
    outcomeDesc: '这里只展示最近可见的成果，完整记录可以到成果库查看。',
    projectOutcome: '项目成果',
    projectOutcomeDesc: '已沉淀的项目和可展示材料。',
    resumeOutcome: '简历资产',
    resumeOutcomeDesc: '最近一次简历分析与优化建议。',
    resumeScore: '简历评分 {{score}}',
    loginTitle: '登录后查看你的成长状态',
    loginDesc: '成长中心会根据你的目标、任务和成果给出下一步建议。',
    previewTitle: '登录后会看到这些',
    previewDesc: '先不用注册也可以去探索方向；当你需要保存目标、任务和成果时再登录。',
    previewGoal: '当前目标',
    previewGoalValue: '下一阶段想达成什么',
    previewStage: '当前阶段',
    previewStageValue: '从方向探索到成果沉淀',
    previewTask: '今日任务',
    previewTaskValue: '今天最值得推进的一步',
    previewNext: '下一步建议',
    previewNextValue: '根据状态给出行动入口',
    previewOutcome: '最近成果',
    previewOutcomeValue: '项目、简历和学习记录',
    loading: '正在加载成长状态...',
    loadFailedTitle: '成长状态加载失败',
    loadFailed: '请稍后重试，或先从方向探索开始。',
    errorEyebrow: '成长中心',
    errorTitle: '暂时无法获取成长状态',
    errorDesc: '接口不可用时，不会影响你继续探索方向或查看成果库。',
    retry: '重试',
    completeFailed: '任务状态更新失败，请稍后再试。',
    competitions: '竞赛证书',
    competitionsDesc: '规划可用于证明能力的竞赛和证书。',
    resume: '简历',
    resumeDesc: '整理可写进简历的经历。',
    interview: '面试',
    interviewDesc: '准备项目表达和常见问题。',
  },
  learningRoute: {
    ...en.learningRoute,
    eyebrow: '学习路线',
    emptyTitle: '先选择方向，再生成学习路线',
    emptyDesc: '学习路线应该服务于你的成长目标。先确定方向或生成成长目标后，再进入对应的学习节点和今日任务。',
    chooseDirection: '去探索方向',
    backGrowth: '回到我的成长',
    guideDirection: '先有方向',
    guideDirectionDesc: '避免一上来就默认学习某个岗位路线。',
    guideTask: '再拆任务',
    guideTaskDesc: '路线会继续落到今日任务，而不是只看长清单。',
    guideSaved: '保存后同步',
    guideSavedDesc: '登录后目标、路线和任务会同步到成长中心。',
    guideSavedDescLoggedIn: '你的目标、路线和任务会同步到成长中心。',
    optionalTitle: '已有旧路线仍可访问',
    optionalDesc: 'Java 后端路线保留为可选路线，不会作为所有学生的默认路线。',
    viewJavaRoute: '查看 Java 后端路线',
    loadingTitle: '正在加载学习路线...',
    continueLearning: '继续学习',
    viewTodayTask: '查看今日任务',
    nodeProgress: '已完成 {{done}}/{{total}} 个节点',
    loadFailedTitle: '路线加载失败',
    loadFailedDesc: '学习路线暂时加载失败，已显示默认路线框架。',
    overviewAria: '学习路线概览',
    currentDirection: '当前方向',
    targetRole: '目标岗位',
    entryLevel: '入门',
    estimatedDays: '{{difficulty}} · 预计 {{days}} 天',
    viewRouteDetail: '查看路线详情',
    todayTask: '今日任务',
    firstNodeTitle: '先从第一个学习节点开始',
    firstNodeDesc: '完成节点后会写入成长中心，并累计成长记录。',
    startTodayTask: '开始今日任务',
    currentStage: '当前阶段',
    waitingRouteData: '等待路线数据',
    routeDataFallback: '如果接口暂时不可用，页面会保持可用并显示友好提示。',
    viewTodayPlan: '查看今日计划',
    stageListAria: '学习路线阶段',
    loadingStage: '正在加载路线',
    loadingStageTitle: '正在准备学习节点',
    loadingStageDesc: '系统正在读取阶段、资源、练习和项目入口。',
    emptyState: '空状态',
    noNodesTitle: '暂时没有学习节点',
    noNodesDesc: '路线数据还没有准备好，请稍后重试，或回到我的成长重新选择学习方向。',
    stageLabel: '阶段 {{order}}',
    stageFallbackDesc: '完成本阶段节点后，继续推进项目和练习。',
    daysValue: '{{days}} 天',
    stageProgress: '{{progress}}% 完成 · {{done}}/{{total}} 个节点',
    learningNode: '学习节点',
    defaultDuration: '30 分钟',
    view: '查看',
    continue: '继续',
    start: '开始',
    typeVideo: '视频',
    typeDocument: '文档',
    typePractice: '练习',
    typeProject: '项目',
    typeReview: '复盘',
    typeLearning: '学习',
    nodeDone: '已完成',
    nodeNotStarted: '未开始',
  },
  projectHub: {
    ...en.projectHub,
    eyebrow: '成果库',
    title: '我的学生成果资产',
    subtitle: '把项目、证明材料和简历素材放在这里，让每一次学习和实践都能说明你的能力。',
    loading: '正在加载成果...',
    loginTitle: '登录后查看你的成果库',
    loginDesc: '项目、GitHub 分析和简历材料会汇总在这里，帮助你把经历变成可展示、可写简历、可用于面试表达的成果资产。',
    previewStart: '先看提升建议',
    previewTitle: '成果库预览',
    previewHeading: '你可以先从三类成果开始',
    previewDesc: '成果库不是工具列表，而是把你的学习、项目和简历材料整理成能说明能力的证据。',
    previewProjectsTitle: '我的项目',
    previewProjectsDesc: '整理已有项目，补齐背景、角色、过程和结果。',
    previewImproveTitle: '项目提升建议',
    previewImproveDesc: '找到下一步该补的能力证据，让项目更像真实成果。',
    previewResumeTitle: '简历材料',
    previewResumeDesc: '把项目过程转成可写进简历和面试表达的素材。',
    githubAsEnhancer: 'GitHub 是成果增强能力',
    githubAsEnhancerDesc: '仓库、提交记录和 README 用来证明项目可信度，不再作为独立工具墙。',
    loadFailedTitle: '成果加载失败',
    loadFailed: '请稍后重试，或先查看本地已有入口。',
    overview: '我的成果概览',
    activeProjects: '进行中项目',
    completedProjects: '已完成项目',
    resumeScore: '简历评分',
    visibleOutcomes: '我的成果',
    existingProjects: '已有项目',
    existingDesc: '先看已有项目，再决定是否包装、补充或增强。',
    noProjectsTitle: '还没有项目成果',
    noProjectsDesc: '可以先从推荐项目或学习路线中选择一个小项目开始。',
    untitledProject: '未命名项目',
    projectFallbackDesc: '暂无项目描述，可以补充目标、职责和结果。',
    improvementTitle: '下一步提升建议',
    improvementDesc: '先选一个能让成果更容易展示的动作，用于申请、面试或复盘。',
    improveProjectTitle: '讲清楚一个项目故事',
    improveProjectDesc: '说明问题、你的角色、推进过程和结果，让别人能看懂你的能力。',
    githubEnhanceTitle: '用 GitHub 补强证据',
    githubEnhanceDesc: '用仓库、提交记录和 README 强化项目可信度与简历价值。',
    resumeTitle: '转成简历材料',
    resumeDesc: '把项目经历整理成可直接放入简历的表达。',
    resumeMaterials: '简历材料',
    resumeEntry: '简历材料入口',
    resumeAsset: '最近简历资产',
    resumeAssetDesc: '由项目或分析记录整理出的简历素材草稿。',
    noResumeAssetTitle: '还没有简历材料',
    noResumeAssetDesc: '先整理一个项目故事，再把它转成可写进简历的表达。',
    improvement: '提升建议',
    viewMyProjects: '查看我的项目',
    prepareResume: '整理简历材料',
    startProjectDesc: '从一个能展示能力的小项目开始。',
  },
  exploreFlow: {
    ...en.exploreFlow,
    majorInterest: '你对目前所学专业感兴趣吗？',
    majorInterestInterested: '感兴趣，希望优先沿本专业发展',
    majorInterestUnsure: '不确定，希望结合能力一起判断',
    majorInterestNotInterested: '不感兴趣，想探索其他领域',
    preferredField: '你真正感兴趣的方向',
    preferredFieldPlaceholder: '例如：新媒体、教育、产品设计、人工智能、金融',
    preferredFieldNote: 'AI 会把本专业能力作为可迁移基础，但优先围绕这个方向推荐岗位。',
    eyebrow: '探索方向',
    title: '找到适合你的成长方向',
    subtitle: '通过了解你的专业、兴趣、目标和学习习惯，帮助你确定下一阶段。',
    startExplore: '开始填写',
    flowAria: '方向探索流程',
    steps: {
      knowSelf: '认识自己',
      aiExplore: 'AI探索',
      profile: '生成方向画像',
      choose: '选择方向',
      goal: '生成 AI 成长路线',
      growth: '进入我的成长',
    },
    selfSection: '认识自己',
    aiExplore: 'AI探索',
    directionPortrait: '方向画像',
    major: '专业',
    majorPlaceholder: '例如：计算机、会计、英语、机械设计',
    grade: '年级',
    gradeFreshman: '大一',
    gradeSophomore: '大二',
    gradeJunior: '大三',
    gradeSenior: '大四',
    gradeGraduate: '研究生',
    interest: '兴趣',
    interestPlaceholder: '你对哪些课程、活动或问题有兴趣？',
    personality: '性格倾向',
    personalityPlaceholder: '例如：喜欢独立研究、喜欢与人沟通、偏实践',
    learningHabit: '学习习惯',
    level: '当前水平',
    levelBeginner: '刚开始了解',
    levelFoundation: '学过基础，缺少完整实践',
    levelIntermediate: '能独立完成项目',
    levelAdvanced: '有工作经验，希望进阶',
    currentSkills: '已经掌握的技能',
    currentSkillsPlaceholder: '例如：React、Vue、TypeScript、性能优化',
    currentSkillsNote: '填写你真正会用的技能，用逗号分隔；不会的可以留空。',
    dailyMinutes: '每天可投入时间',
    dailyMinutesOption: '每天 {{minutes}} 分钟',
    dailyMinutesNote: 'AI 会按这个时间控制每日任务量。',
    habitVideo: '看视频入门',
    habitReading: '读资料总结',
    habitPractice: '边做边学',
    habitProject: '靠项目推进',
    habitDeadline: '需要截止日期推动',
    goal: '当前目标',
    goalUnsure: '还不确定',
    goalInternship: '准备实习',
    goalJob: '准备就业',
    goalGraduate: '考研/升学',
    goalPortfolio: '做作品集',
    goalStable: '稳定发展',
    mbti: 'MBTI（可选）',
    mbtiPlaceholder: '例如 INFP / ESTJ，不知道可留空',
    mbtiNote: 'MBTI 只作为辅助参考，不作为决定因素。',
    emptyTitle: '先填写你的当前状态',
    emptyDesc: '填写专业、年级、兴趣和目标后，再生成方向画像。系统会先解释为什么适合、现在缺什么，以及下一步能做什么。',
    formTitle: '填写你的当前状态',
    formDesc: '这一步只收集方向探索需要的背景信息，生成结果前可以随时调整。',
    stepProgress: 'Step {{current}}/{{total}}',
    stepMajorTitle: '先告诉我你的专业和年级',
    stepMajorDesc: '这会帮助判断你当前处在什么阶段，以及哪些方向更适合作为下一步。',
    stepInterestTitle: '你对什么更有兴趣',
    stepInterestDesc: '可以写课程、社团、活动、话题，或者你平时会主动关注的问题。',
    stepPersonalityTitle: '描述你的做事方式',
    stepPersonalityDesc: '性格只是参考。MBTI 可填可不填，不会作为决定因素。',
    stepHabitTitle: '选择你的学习习惯',
    stepHabitDesc: '成长计划要贴合你真实能坚持的方式，而不是理想化日程。',
    stepGoalTitle: '选择你现在最想解决的目标',
    stepGoalDesc: '这会决定结果更偏向实习、作品集、升学，还是稳定发展。',
    previousStep: '上一步',
    nextStepButton: '下一步',
    resultsTitle: '查看你的方向画像',
    resultsDesc: '先看适合原因、当前优势、当前不足和下一步行动，再选择一个方向生成成长目标。',
    editProfile: '修改填写内容',
    needFormTitle: '请先填写当前状态',
    needFormDesc: '方向画像会根据你的专业、兴趣、学习习惯和目标生成。',
    generatePortrait: '生成方向画像',
    reviewDirection: '查看画像',
    selected: '已选择',
    directionProfile: '方向画像',
    directionPortraitDesc: '下面的建议来自你填写的当前状态。重点看原因、优势、差距和下一步。',
    recommendedDirections: 'AI 推荐岗位',
    selectedDirection: '当前选择',
    reviewSelectedDirection: '查看并生成',
    closeFirstGap: '先用一个小任务验证并补齐：{{gap}}',
    auditBasics: '先完成方向基础能力盘点',
    noGapData: '生成路线时进一步分析',
    companionDirectionText: '你选择的是“{{category}}”下的“{{direction}}”，后续计划会围绕真实技能差距展开。',
    aiAnalyzingTitle: 'AI 正在分析适合你的岗位',
    aiAnalyzingDesc: '正在结合专业、兴趣、学习方式和目标，从内部职业库筛选候选方向。',
    aiFallback: 'AI 岗位分析暂时不可用，已切换为职业库推荐。',
    whyFit: '为什么适合',
    currentStrengths: '当前优势',
    currentGaps: '当前不足',
    nextAction: '下一步行动',
    possibleOutcome: '可以产生什么成果',
    companionObservation: 'AI伙伴观察',
    companionObservationText: '小助手观察：你选择的方向是“{{direction}}”。从当前信息看，{{strength}}',
    companionAdvice: '个性化建议',
    companionAdviceText: '今天先不要追求完整规划，先完成一个可执行动作：{{action}} 之后把结果沉淀成：{{outcome}}',
    existingLogic: '方向生成说明',
    existingLogicDesc: '我们会根据你的专业、年级、兴趣、学习习惯和目标，生成更适合下一阶段的成长方向。',
    initialStage: '方向探索阶段',
    createGrowthGoal: '选择岗位并生成 AI 成长路线',
    generatingGoal: 'AI 正在设计成长路线...',
    createGoalFailed: 'AI 成长路线生成失败，请稍后再试。',
    backGrowth: '回到我的成长',
    directions: {
      data: {
        title: '数据分析与业务洞察方向',
        why: '适合喜欢观察问题、整理信息，并愿意用数据解释现象的学生。',
        strengths: '课程报告、调研、比赛和表格分析都能作为起点。',
        gaps: '需要补数据清洗、可视化、业务理解和结论表达。',
        next: '选一个校园或行业问题，做一份数据分析小报告。',
        outcome: '可以形成数据分析作品、报告和面试讲述案例。',
      },
      frontend: {
        title: '前端与产品体验方向',
        why: '适合喜欢把想法做成可用页面、关注交互体验，并愿意用作品证明能力的学生。',
        strengths: '页面作品、GitHub仓库和产品思考都能成为可展示证据。',
        gaps: '需要补交互细节、响应式体验、工程规范和项目复盘。',
        next: '选一个真实场景，做出可访问的页面演示，并写清楚设计取舍。',
        outcome: '可以形成在线Demo、README和项目故事，证明产品与工程能力。',
      },
      backend: {
        title: '后端工程与系统方向',
        why: '适合喜欢逻辑、系统、数据模型，并愿意积累稳定技术深度的学生。',
        strengths: '课程实验、管理系统和接口项目都能扩展成完整作品。',
        gaps: '需要补数据库设计、API结构、登录权限和部署实践。',
        next: '做一个小型业务系统，把接口文档、数据表和部署流程补完整。',
        outcome: '可以形成可部署系统项目、接口文档、数据库设计和简历项目经历。',
      },
      content: {
        title: '内容运营与增长方向',
        why: '适合能持续输出、观察数据，并理解平台和用户的学生。',
        strengths: '非技术专业也能通过内容、选题和复盘快速产生成果。',
        gaps: '需要稳定输出、选题策略和数据复盘，而不是泛泛写文案。',
        next: '选择一个细分主题，连续发布7条内容，并总结数据规律。',
        outcome: '可以形成内容作品集，包含选题逻辑、样例内容和效果复盘。',
      },
      product: {
        title: '产品助理方向',
        why: '适合喜欢用户问题、需求、流程和跨角色协作的学生。',
        strengths: '原型、产品文档和项目复盘可以连接业务、设计和技术。',
        gaps: '需要补结构化PRD、竞品分析、数据意识和执行证据。',
        next: '选择一个校园场景，写一份小PRD并画出3个关键页面原型。',
        outcome: '可以形成包含问题、用户流程、原型和复盘的产品案例。',
      },
      public: {
        title: '公考国企与稳定方向',
        why: '适合重视稳定发展、结构化表达和长期准备的学生。',
        strengths: '学生工作、调研、志愿服务和写作经历都可以转化为材料。',
        gaps: '需要长期备考、申论结构和经历素材整理。',
        next: '建立一份个人经历素材库，并开始行测或申论基础复盘。',
        outcome: '可以形成备考档案，包含经历故事、写作素材和周复盘记录。',
      },
    },
  },
  projectHealth: {
    ...en.projectHealth,
    eyebrow: 'GitHub 项目分析',
    title: 'GitHub 项目分析',
    description: '把 GitHub 项目整理成学习、简历和面试都能用的报告。',
    guestTitle: '登录后生成并保存 GitHub 项目分析。',
    guestDescription: '登录后可以查看历史报告、刷新分析，并持续完善项目亮点和面试讲述。',
    goLogin: '登录',
    inputTitle: '输入 GitHub 仓库地址',
    inputDescription: '支持 GitHub 链接或 owner/repo 格式。',
    repoAddress: '仓库地址',
    repoPlaceholder: '粘贴 GitHub 项目链接，例如 https://github.com/vercel/next.js',
    start: '开始分析',
    creating: '正在创建...',
    invalidRepo: '请输入有效的 GitHub 仓库地址，例如 https://github.com/owner/repo',
    invalidRepoFormat: '链接格式不正确，请粘贴 GitHub 项目链接或 owner/repo。',
    githubRepoNotFound: '没有找到公开项目，请检查链接或确认仓库不是私有仓库。',
    githubRateLimited: 'GitHub API 暂时限流，请稍后再试。',
    aiAnalysisFailed: 'AI 分析失败，请稍后再试。',
    networkError: '网络异常，请检查服务或部署配置。',
    myGithubProjects: '我的 GitHub 项目',
    myGithubProjectsDescription: '分析过的 GitHub 项目会出现在这里，方便重新分析或查看历史报告。',
    noSavedGithubProjects: '还没有保存的 GitHub 项目。分析一个项目后会出现在这里。',
    syncGithubProjects: '同步我的 GitHub 项目',
    githubSyncFailed: '同步 GitHub 项目失败，请稍后再试。',
    historyEyebrow: '历史记录',
    historyTitle: '项目报告',
    historyDescription: '展示最近的项目报告，按更新时间排序。',
    loadingHistory: '正在加载报告',
    emptyHistoryTitle: '还没有项目报告',
    emptyHistoryMessage: '输入 GitHub 仓库地址后，生成的报告会出现在这里。',
    viewDetail: '查看详情',
    refresh: '刷新',
    refreshReport: '刷新报告',
    reanalyze: '重新分析',
    deleteReport: '删除报告',
    selectReport: '选择一份报告',
    selectReportMessage: '在历史报告中点击查看详情。',
    detailEyebrow: '报告详情',
    score: '评分',
    generatedAt: '生成时间',
    refreshedAt: '刷新时间',
    summary: '摘要',
    errorInfo: '错误信息',
    progress: '分析进度',
    reportContent: '报告内容',
    copyShare: '生成分享链接',
    copyPromotion: '复制推广文案',
    poster: '生成海报',
    openShare: '打开分享页',
    pendingMessage: '正在分析 GitHub 数据、README 和项目活跃度，通常需要 20-60 秒。',
    createNotice: '报告任务已创建，正在抓取 GitHub 数据并进行 AI 分析。',
    existingNotice: '已复用这个仓库的已有报告。如果仍在处理中，会继续分析。',
    refreshNotice: '报告已重新进入分析队列。',
    deletedNotice: '报告已删除。',
    maintenanceRisk: '维护风险',
    risks: '风险',
    learningPath30: '30 天学习路径',
    techStackPending: '技术栈待分析',
    suitableUsersFallback: '适合寻找练习项目、简历素材和面试准备的人',
    highlightFallback: '自动整理项目亮点、学习价值和讲述要点',
    posterPreview: '海报预览',
    posterNote: '当前版本提供适合截图分享的卡片，后续可加入真实图片导出。',
    loadHistoryFailed: '报告历史加载失败，请稍后再试。',
    loadDetailFailed: '报告详情加载失败，请稍后再试。',
    createFailed: '报告创建失败，请检查仓库地址后重试。',
    incomingRepoInvalid: '传入的 GitHub 仓库地址无效，请检查后重试。',
    refreshFailed: '报告刷新失败，请稍后再试。',
    deleteConfirm: '确定删除这份项目报告吗？',
    deleteFailed: '删除报告失败，请稍后再试。',
    checkingLogin: '正在检查登录状态',
    noReportSummary: '暂无报告摘要。',
    loadingDetail: '正在加载报告详情',
    updatedPrefix: '更新时间：',
    pollTimeout: '分析时间比预期更长，请稍后刷新查看结果。',
    structuredContentMissing: '报告已完成，但结构化内容未加载，请刷新后重试。',
    noReportContent: '暂无报告内容。',
  },
  growthCompanion: {
    ...en.growthCompanion,
    metaTitle: 'AI伙伴 - 青途 AI',
    metaDescription: '和AI伙伴讨论你的当前状态、方向选择与下一步行动。',
    eyebrow: 'AI伙伴',
    title: '把你的困惑说清楚，再决定下一步',
    subtitle: 'AI伙伴会结合你的成长状态，帮你梳理目标、任务和长期方向。',
    loginTitle: '登录后使用AI伙伴',
    loginDesc: '你可以先了解它能帮你做什么；登录后，对话会保存，并能同步到我的成长。',
    tryExplore: '先去探索方向',
    guestPreviewTitle: 'AI伙伴能帮什么',
    guestPreviewHeading: '把模糊困惑变成下一步行动',
    guestValueClarify: '梳理困惑：把“不知道该做什么”拆成方向、能力和现实限制。',
    guestValueNext: '生成下一步：把聊天结果落到一个今天可以开始的小行动。',
    guestValueSync: '同步成长中心：登录后把目标、任务和建议沉淀到我的成长。',
    exampleTitle: '可以这样开始',
    exampleDirection: '我大一，还不知道适合什么方向。',
    exampleBehind: '我大二感觉落后了，不知道该补项目还是基础。',
    exampleInternship: '我准备实习，但项目和简历都很弱。',
    start: '开始对话',
    send: '发送',
    thinking: '正在思考...',
    placeholder: '说说你现在的困惑，例如：我不知道大二该补什么。',
    profileTitle: '成长画像',
    currentStatus: '当前状态',
    recommendedDirection: '推荐方向',
    dailyAdvice: '今日建议',
    futureAdvice: '长期建议',
    generateProfile: '生成成长画像',
    exploring: '正在探索',
    shortTerm: '短期重点',
    longTerm: '长期方向',
    strengths: '优势',
    weaknesses: '待提升',
    preferences: '偏好',
    emptyLongTerm: '聊过方向后，这里会沉淀你的长期目标。',
    emptyShortTerm: '开始对话后，这里会记录最近要推进的重点。',
    emptyPreferences: '你提到的学习习惯和偏好会保存在这里。',
    noRecentReason: '还没有足够记录，先聊聊你的当前情况。',
    notQuestionnaire: '不是问卷',
    notQuestionnaireDesc: '你可以直接描述问题，AI伙伴会帮你整理。',
    errorStart: '对话启动失败，请稍后再试。',
    errorSend: '消息发送失败，请稍后再试。',
    errorProfile: '成长画像生成失败，请稍后再试。',
    adjustmentTitle: '计划调整草案',
    adjustmentUnchanged: '当前计划尚未修改，请确认草案后再应用。',
    adjustmentDailyTime: '建议每日时间',
    adjustmentReason: '调整原因',
    adjustmentChanges: '建议变化',
    minutes: '分钟',
    applyAdjustment: '应用这个调整',
    keepCurrentPlan: '保留当前计划',
    adjustmentApplied: '调整已应用，并生成了新的计划版本。',
    adjustmentDismissed: '已忽略草案，当前计划保持不变。',
    errorAdjustment: '计划更新失败，请稍后再试。',
    versionHistory: '计划版本历史',
    versionHistoryTitle: '查看成长计划如何变化',
    versionHistoryDesc: '恢复历史版本时会创建新的活动副本，不会删除任何历史。',
    currentVersion: '当前版本',
    historyVersion: '历史版本',
    unnamedPlan: '成长计划',
    originalGeneratedPlan: '原始 AI 生成计划',
    restoreVersion: '恢复这个版本',
    versionRestored: '已将所选版本恢复为新的当前计划。',
    errorVersionRestore: '版本恢复失败，请刷新后再试。',
    weeklyTasks: '七天执行计划',
    weeklyTasksTitle: '把当前计划变成每天一个任务',
    weeklyTasksDesc: '任务来自当前计划的阶段内容，完成情况和难度反馈将用于后续调整建议。',
    generateWeeklyTasks: '生成我的七天任务',
    completeTask: '完成',
    tooHard: '太难了',
    skipTask: '没时间／跳过',
    errorWeeklyTasks: '七天任务生成失败，请稍后再试。',
    errorTaskAction: '任务状态更新失败，请稍后再试。',
    taskStatus: {
      pending: '待完成',
      completed: '已完成',
      skipped: '已跳过',
    },
    adjustmentSuggested: '本周可能需要更轻的计划',
    createAdjustmentDraft: '生成调整草案',
    evaluationReason: {
      too_hard: '多个任务被标记为太难，建议保留职业目标并降低当前难度。',
      no_time: '多个任务因时间不足被跳过，建议降低每日任务量。',
      low_completion: '多次尝试后完成率低于 50%，建议缩小下一步行动范围。',
    },
    daily: {
      start_small: '今天先完成一个很小但明确的成长动作。',
      continue_learning: '继续推进下一个学习任务。',
      fix_practice: '先修正一个薄弱练习结果。',
      push_project: '今天推进一个项目任务。',
      weekly_review: '做一次简短复盘，把进展整理成成果证据。',
    },
    companion: {
      greeting: '你好，我会慢慢了解你。可以先说你的专业、年级，或者最近最困惑的事。',
      ready_report: '我已经有足够信息生成第一版成长画像了。你可以先生成画像，之后继续补充。',
      ask: {
        major: '你现在是什么专业或领域？这会帮助我判断更适合你的成长路线。',
        grade: '你现在是大几或处在什么阶段？不同阶段的重点会不一样。',
        interests: '最近哪些课程、项目或话题会让你更愿意投入？',
        goal: '你更想先解决方向、学习节奏、项目成果，还是实习就业？',
        difficulty: '现在最卡住你的地方是什么？可以是目标模糊、基础薄弱、项目少或简历不会写。',
        habit: '你平时更适合视频学习、项目练习、阅读整理，还是有人给 deadline？',
        personality: '你觉得自己更偏外向沟通、安静思考、动手实践，还是整理规划？',
      },
    },
  },
  pet: {
    assistant: 'AI 伙伴助手',
    name: 'AI 小助手',
    open: '打开 AI 伙伴助手',
    title: '点击打开 AI 伙伴助手',
    loginNote: '登录后可以签到、喂食并保存伙伴形象。',
    loginButton: '登录并使用 AI 伙伴',
    loading: '正在加载伙伴状态',
    petType: '伙伴形象',
    level: '等级',
    mood: '状态',
    food: '食物',
    exp: '经验',
    checkinState: '今日签到：{{state}}',
    checked: '已完成',
    unchecked: '未签到',
    noFoodHint: '食物不多了，明天签到可以继续领取。',
    hungryHint: '我有点饿了，要喂一下吗？',
    dailyTasks: '今日任务',
    checkin: '每日签到',
    rewardFood: '+1 食物',
    rewardAnalysis: '+2 食物',
    analyzeProjectTask: '分析一个 GitHub 项目',
    favoriteTask: '收藏一个项目',
    received: '已领取',
    changeSkin: '更换形象',
    feed: '喂食',
    noFood: '没有食物了，签到后可以领取',
    askAi: '问 AI',
    goAnalyze: '分析 GitHub 项目',
    drop: '拖到这里，我来帮你分析！',
    catching: '收到项目，开始分析！',
    thinking: '我正在阅读这个项目',
    success: '报告已生成',
    sad: '分析失败，稍后再试',
    feeding: '吃饱啦，状态很好！',
    notChecked: '今天还没有签到',
    noFoodShort: '没有食物了，签到领取',
    happy: '今天状态很好！',
    hungry: '我有点饿了',
    idle: '把 GitHub 项目拖给我，我帮你看看。',
    guestStatus: '登录后可以签到、喂食并保存伙伴形象。',
    happyStatus: '状态不错，适合分析一个项目！',
    growthGuideLabel: '成长伙伴',
    growthGuideTitle: '你好，我是你的成长伙伴，让我先了解你。',
    growthGuideDesc: '我会先了解你的专业、年级、兴趣、基础、目标和当前困惑，再带你生成成长画像、推荐方向、学习路线和第一阶段任务。',
    growthGuideMajor: '专业',
    growthGuideGrade: '年级',
    growthGuideInterest: '兴趣与基础',
    growthGuideGoal: '想发展的方向',
    growthGuideTime: '每周投入时间',
    growthGuideConfusion: '当前困惑',
    startGrowthGuide: '开始让我了解你',
    growthGuideLongTerm: '之后你也可以告诉我：想换方向、目标变了、最近没时间学习，我会帮你调整计划。',
  },
}

export default zh
